// firebase.ts
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// -- Env: keep REACT_APP_* for CRA. If you later move to Vite/Next, rename to VITE_*/NEXT_PUBLIC_*.
const firebaseConfig = {
  apiKey:        process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain:    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,   // e.g. yourapp.firebaseapp.com
  projectId:     process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,// e.g. yourapp.appspot.com
  // Optional but nice to include for completeness / future features:
  // appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

// Guard missing config early (helpful in staging/previews)
for (const [k, v] of Object.entries(firebaseConfig)) {
  if (!v) { throw new Error(`Missing Firebase env: ${k}`); }
}

// Prevent "Firebase App named '[DEFAULT]' already exists" in dev HMR
export const app  = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Core services
export const auth = getAuth(app);
auth.useDeviceLanguage();
export const db   = getFirestore(app);
export const storage = getStorage(app); // uses the bucket from storageBucket

// Make auth persistence explicit (stay signed in across tabs/reloads)
setPersistence(auth, browserLocalPersistence);

// Convenience: Google sign-in that refreshes claims (roles/subscription) right away
export async function signInWithGoogle() {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' }); // NEW
  try {
    const res = await signInWithPopup(auth, provider);
    await res.user.getIdToken(true);
    return res.user;
  } catch (e: any) {
    // Optional: fallback for popup-blocked environments
    // if (e?.code === 'auth/popup-blocked') await signInWithRedirect(auth, provider);
    throw e;
  }
}


// Helper: fetch a fresh ID token (useful before calling your Vercel API)
export async function getFreshIdToken(forceRefresh = false): Promise<string | null> {
  const u = auth.currentUser;
  return u ? u.getIdToken(forceRefresh) : null;
}

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.log('Firebase projectId:', app.options.projectId);
}

// at the end of the file
if (process.env.NODE_ENV === 'development') {
  (window as any).__FB_AUTH__ = auth;
}
